import { useDispatch } from 'react-redux'
import { SUPPORT_STATUS, SUPPORT_STATUS_CTA_LABEL, SUPPORT_STATUS_TITLE } from 'app-constants'
import { AICard } from 'components'
import { STATICS } from 'statics'
import { sendWhatsappMessage } from 'utils'
import './style.scss'

export function HasConnection({ data }) {
  const { detailedMessage } = data
  const dispatch = useDispatch()

  function handleCtaTalkAttendantClick() {
    dispatch(sendWhatsappMessage)
  }

  return (
    <div className='support-has-connection'>
      <AICard
        title={SUPPORT_STATUS_TITLE[SUPPORT_STATUS.HAS_CONNECTION]}
        message={detailedMessage}
        ctaLabel={SUPPORT_STATUS_CTA_LABEL.TALK_WITH_ATTENDANT}
        onCtaClick={handleCtaTalkAttendantClick}
        icon={
          <div className='icon'>
            <STATICS.CHECK_CIRCLE />
          </div>
        }
      />
    </div>
  )
}
